import { Content, Portal as RadixPortal } from "@radix-ui/react-dropdown-menu";
import { selectProjectMemberList } from "app/containers/Features/components/MemberSelection/redux/selector";
import { selectUserFormData } from "app/redux/selector";
import clsx from "clsx";
import React, { ComponentProps, FC } from "react";
import { useSelector } from "react-redux";
import { AssigneeHistory } from "./AssigneeHistory/AssigneeHistory";
import { Header } from "./Header";
import SeparateSpace from "./SeparateSpace";

export const Portal: FC<{
  assigneeId?: string;
  assigneeHistoryProps?: ComponentProps<typeof AssigneeHistory>;
  headerProps?: ComponentProps<typeof Header>;
  className?: string;
}> = ({ assigneeId, assigneeHistoryProps, headerProps, className }) => {
  // Global States
  const projectMembers = useSelector(selectProjectMemberList);
  const currentUserDetail = useSelector(selectUserFormData);

  // Variables
  const userId = projectMembers.find(
    (member) => member._id === assigneeId,
  )?.userId;
  const isAssignee = currentUserDetail._id === userId;

  return (
    <RadixPortal>
      <Content
        align="start"
        sideOffset={2}
        className={clsx(
          "w-[var(--radix-dropdown-menu-trigger-width)] flex flex-col bg-white rounded border border-gray-100 shadow-[2px_2px_6px_0px_rgba(237,239,242,0.70)] z-50",
          className,
        )}
      >
        {isAssignee && (
          <>
            <SeparateSpace />
            <Header {...headerProps} />
            <SeparateSpace className="border-b border-gray-100" />
          </>
        )}
        <AssigneeHistory {...assigneeHistoryProps} />
      </Content>
    </RadixPortal>
  );
};
